import type { PublicStore } from "@/types/store";

function normalizePublicUrl(
  value: string | null,
): string | null {
  if (!value) {
    return null;
  }

  if (value.startsWith("http://api-dev.fornecedor.net")) {
    return value.replace(
      "http://api-dev.fornecedor.net",
      "https://api-dev.fornecedor.net",
    );
  }

  if (value.startsWith("http://api.fornecedor.net")) {
    return value.replace(
      "http://api.fornecedor.net",
      "https://api.fornecedor.net",
    );
  }

  return value;
}

function normalizeCampaign<T extends {
  desktop_art_url: string;
  mobile_art_url: string | null;
}>(campaign: T): T {
  return {
    ...campaign,
    desktop_art_url:
      normalizePublicUrl(campaign.desktop_art_url) ?? "",
    mobile_art_url: normalizePublicUrl(campaign.mobile_art_url),
  };
}

export function normalizePublicStore(
  store: PublicStore,
): PublicStore {
  return {
    ...store,
    company: {
      ...store.company,
      logo_url: normalizePublicUrl(
        store.company.logo_url,
      ),
      banner_url: normalizePublicUrl(
        store.company.banner_url,
      ),
    },
    campaigns: store.campaigns
      ? {
          modal: store.campaigns.modal
            ? {
                ...store.campaigns.modal,
                desktop_art_url:
                  normalizePublicUrl(
                    store.campaigns.modal.desktop_art_url,
                  ) ?? "",
                mobile_art_url: normalizePublicUrl(
                  store.campaigns.modal.mobile_art_url,
                ),
              }
            : null,
          banners: {
            after_featured: store.campaigns.banners.after_featured
              ? normalizeCampaign(
                  store.campaigns.banners.after_featured,
                )
              : null,
            between_most_viewed_and_categories:
              store.campaigns.banners
                .between_most_viewed_and_categories
                ? normalizeCampaign(
                    store.campaigns.banners
                      .between_most_viewed_and_categories,
                  )
                : null,
            before_footer: store.campaigns.banners.before_footer
              ? normalizeCampaign(
                  store.campaigns.banners.before_footer,
                )
              : null,
          },
        }
      : undefined,
    products: store.products.map((product) => ({
      ...product,
      primary_image_url: normalizePublicUrl(
        product.primary_image_url,
      ),
      images: product.images.map((image) => ({
        ...image,
        image_url:
          normalizePublicUrl(image.image_url) ??
          image.image_url,
      })),
    })),
    best_sellers: (store.best_sellers ?? []).map(
      (product) => ({
        ...product,
        primary_image_url: normalizePublicUrl(
          product.primary_image_url,
        ),
        images: product.images.map((image) => ({
          ...image,
          image_url:
            normalizePublicUrl(image.image_url) ??
            image.image_url,
        })),
      }),
    ),
    most_viewed: (store.most_viewed ?? []).map(
      (product) => ({
        ...product,
        primary_image_url: normalizePublicUrl(
          product.primary_image_url,
        ),
        images: product.images.map((image) => ({
          ...image,
          image_url:
            normalizePublicUrl(image.image_url) ??
            image.image_url,
        })),
      }),
    ),
  };
}
